import { useState, useEffect } from 'react';

export const useCallTimer = (startTime?: string) => {
  const [timer, setTimer] = useState<string>('00:00');

  useEffect(() => {
    if (!startTime) return;

    const updateTimer = () => {
      const start = new Date(startTime);
      const now = new Date();
      
      if (isNaN(start.getTime())) {
        setTimer('00:00');
        return;
      }
      
      const diffInSeconds = Math.floor((now.getTime() - start.getTime()) / 1000);

      if (diffInSeconds <= 0) {
        setTimer('00:00');
        return;
      }
      
      const hours = Math.floor(diffInSeconds / 3600);
      const minutes = Math.floor((diffInSeconds % 3600) / 60);
      const seconds = diffInSeconds % 60;
      
      const formattedTime = hours > 0 
        ? `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        : `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      
      setTimer(formattedTime);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  return timer;
};
